import { carouselData } from './carouselData';
import 'swiper/css';
import 'swiper/css/navigation';
import React from 'react';
import './carousel.scss';

import { Swiper, SwiperSlide } from 'swiper/react';

import { Navigation } from 'swiper/modules';

function Carousel2({ dataIndex, videoSrc, setCurrent, container }) {
  const data = carouselData[dataIndex];

  return (
    <Swiper
      className="swiper carousel__contents__photoContainer"
      modules={[Navigation]}
      navigation={{
        nextEl: `.carousel__contents__arrows-right-${dataIndex}`,
        prevEl: `.carousel__contents__arrows-left-${dataIndex}`
      }}
      onSlideChange={(self) => {
        container.current.style.animation = 'fade-out 0.4s linear 0s forwards';
        setTimeout(() => {
          container.current.style.animation = 'fade-in 0.4s linear 0s forwards';
          setCurrent(self.activeIndex);
        }, 500);
      }}
      freeMode={true}
      id="carousel-swiper"
    >
      {data.contents.map((content, i) => {
        return (
          <SwiperSlide
            key={i}
            className="swiper-slide carousel__contents__photoContainer__photos__imgs"
          >
            <img
              className="carousel__contents__photoContainer__photos__img"
              alt=""
              src={videoSrc === 'large' ? content.photoD : content.photo}
            />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
}

export default Carousel2;
